import { createContext } from "react";

export interface AudioControlsContextValue {
  isPlaying: boolean;
  isAudioReady: boolean;
  /** True while the authorized audio bytes are still being downloaded. */
  isResolving: boolean;
  togglePlay: () => void;
  skipForward: () => void;
  skipBackward: () => void;
  playbackRate: number;
  cyclePlaybackRate: () => void;
  volume: number;
  handleVolumeChange: (volume: number) => void;
}

export const AudioControlsContext = createContext<AudioControlsContextValue | null>(null);
